import { useEffect, useState } from 'react'
import { useLazyGetMediaFileQuery } from '@/features/media/api'
import documentPlaceholder from './assets/document.jpg'
import imagePlaceholder from './assets/image.png'
import videoPlaceholder from './assets/video.jpg'
import { MediaSizes, MediaType } from './types'

export interface MediaImageParams {
  mediaType: MediaType
  mediaCode: number
  fileAttachments: {
    name: string
    imageSizeCode: MediaSizes
  }[]
}

export const useMediaImage = (
  item: MediaImageParams,
  size = MediaSizes.Medium,
  shouldFetch = true,
) => {
  const [currentImageUrl, setCurrentImage] = useState<string>()

  const { mediaType } = item
  const [getMediaFile, mediaFileRequest] = useLazyGetMediaFileQuery()
  const [isFallback, setFallback] = useState(true)

  useEffect(
    function setImageToPlaceholder() {
      if (mediaType === MediaType.Document) {
        setCurrentImage(documentPlaceholder)
      }
      if (mediaType === MediaType.Video) {
        setCurrentImage(videoPlaceholder)
      }
      if (mediaType === MediaType.Image) {
        if (!currentImageUrl) setCurrentImage(imagePlaceholder)

        let imageData = item.fileAttachments.find(
          (file) => file.imageSizeCode === size,
        )

        //Fallback to largest non-original size if size isn't present
        if (!imageData)
          imageData =
            item.fileAttachments.find(
              (file) => file.imageSizeCode === MediaSizes.Medium,
            ) ??
            item.fileAttachments.find(
              (file) => file.imageSizeCode === MediaSizes.Small,
            )

        if (imageData && shouldFetch) {
          getMediaFile(
            {
              mediaCode: item.mediaCode,
              fileName: imageData.name,
            },
            true,
          )
        }
      }
    },
    [mediaType, shouldFetch, size, item.mediaCode, item.fileAttachments],
  )

  useEffect(
    function updateImageToResult() {
      if (mediaFileRequest.data) {
        setCurrentImage(mediaFileRequest.data)
        setFallback(false)
      }
    },
    [mediaFileRequest.data],
  )

  return {
    url: currentImageUrl,
    request: mediaFileRequest,
    isFallback,
  }
}
